import type { CommerceClient } from '@altazion/commerce-sdk-core'

import {
  createAltazionExtension,
  type AltazionActionEventDetail,
  type AltazionActionErrorDetail,
  type AltazionExtensionHandle,
  type AltazionSuccessEventKind,
} from './altazion-engine'
import {
  cartModuleDefinition,
  type AltazionCartActionName,
} from './modules/cart'
import {
  sessionModuleDefinition,
  type AltazionSessionActionName,
} from './modules/session'
import {
  marketingModuleDefinition,
  type AltazionMarketingActionName,
} from './modules/marketing'
import {
  storesModuleDefinition,
  type AltazionStoresActionName,
} from './modules/stores'

export type { AltazionCartActionName }
export type { AltazionMarketingActionName }
export type { AltazionSessionActionName }
export type { AltazionStoresActionName }
export type {
  AltazionActionEventDetail,
  AltazionActionErrorDetail,
  AltazionExtensionHandle,
  AltazionSuccessEventKind,
}

export type AltazionCartEventDetail<TResult = unknown> = AltazionActionEventDetail<
  'cart',
  AltazionCartActionName,
  TResult
>

export type AltazionSessionEventDetail<TResult = unknown> = AltazionActionEventDetail<
  'session',
  AltazionSessionActionName,
  TResult
>

export type AltazionMarketingEventDetail<TResult = unknown> = AltazionActionEventDetail<
  'marketing',
  AltazionMarketingActionName,
  TResult
>

export type AltazionStoresEventDetail<TResult = unknown> = AltazionActionEventDetail<
  'stores',
  AltazionStoresActionName,
  TResult
>

/**
 * Extension HTMX Altazion.
 *
 * - Ajoute les headers de contexte Altazion sur les requêtes HTMX
 * - Interprète les attributs `hx-altazion-cart-action`, `hx-altazion-session-action`,
 *   `hx-altazion-marketing-action` et `hx-altazion-stores-action`
 *   pour appeler le SDK core
 * - Émet des événements DOM `altazion:cart:*`, `altazion:session:*`,
 *   `altazion:marketing:*` et `altazion:stores:*`
 *   exploitables par HTMX
 */
export function registerAltazionExtension(client: CommerceClient): AltazionExtensionHandle {
  return createAltazionExtension(client, [
    cartModuleDefinition,
    sessionModuleDefinition,
    marketingModuleDefinition,
    storesModuleDefinition,
  ])
}

export const registerAltazionAuthExtension = registerAltazionExtension
